import { atom } from 'jotai'
import { Athlete } from './athlete';

export const athletesAtom = atom([] as Athlete[]);

